/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePhaseDto } from '../../models/response-phase-dto';

export interface PhasesControllerFindAll$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Pathway ID for filtering
 */
  pathwayId?: string;

/**
 * Phase counter for filtering
 */
  counter?: number;

/**
 * Phase status for filtering
 */
  status?: 'planned' | 'pending' | 'active' | 'completed' | 'skipped' | 'locked';

/**
 * Phase name for partial matching
 */
  name?: string;

/**
 * Template phase ID for filtering
 */
  templatePhaseId?: string;

/**
 * Start date range for filtering (from date).
 */
  startDateFrom?: string;

/**
 * Start date range for filtering (to date).
 */
  startDateTo?: string;

/**
 * End date range for filtering (from date).
 */
  endDateFrom?: string;

/**
 * End date range for filtering (to date).
 */
  endDateTo?: string;

/**
 * Limit for pagination
 */
  limit?: number;

/**
 * Offset for pagination
 */
  offset?: number;
}

export function phasesControllerFindAll(http: HttpClient, rootUrl: string, params: PhasesControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePhaseDto>>> {
  const rb = new RequestBuilder(rootUrl, phasesControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('tenant', params.tenant, {});
    rb.query('pathwayId', params.pathwayId, {});
    rb.query('counter', params.counter, {});
    rb.query('status', params.status, {});
    rb.query('name', params.name, {});
    rb.query('templatePhaseId', params.templatePhaseId, {});
    rb.query('startDateFrom', params.startDateFrom, {});
    rb.query('startDateTo', params.startDateTo, {});
    rb.query('endDateFrom', params.endDateFrom, {});
    rb.query('endDateTo', params.endDateTo, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponsePhaseDto>>;
    })
  );
}

phasesControllerFindAll.PATH = '/thalea-pathways/phases';
